// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__cLM2H","main":"Home_main__5FsXD","loader":"Home_loader__+NuTu"};